module.exports = __webpack_public_path__ + "media/images/admin/icons/frown-65c267ab593555796e1f30575f12e6e2.svg";